import React, { useRef, useEffect, useCallback, useState} from 'react';
import {useCanvasMouse} from './useCanvasMouse.js';
import {useForces} from './useForces.js';
import Forces from './Forces.js';
import CanvasRegions from './CanvasRegions.js';
import ShaderCanvas from './ShaderCanvas.js';
import PlaneCanvas from './PlaneCanvas.js';
import {connect} from 'react-redux';

const CanvasManager = ({
    isRegionMode,
    selectedColor,
    setMacroToShow,
    startDragging,
    coords,
    filteredParameters,
    parameters,
    macroToShow,
    setParameterMinMax,
    setEffectParameterValues,
    containerRef,
    effect,
    selected,
    selection,
    parameterSelected,
    sequencerEngine,
    macros,
    splineTension,
    ...props
}) => { 
    let ctxt = useRef(undefined);
    let forcePaths = useRef([]);
    let paths = useRef({});
    let macroPaths = useRef({});
 
    let {drawForces, getForceParameters}  = useForces(effect, ctxt);

    let {onClick, onMouseMove, onMouseUp, onMouseDown} = useCanvasMouse({
        forcePaths,
        effect,
        containerRef,
        ctxt,
        selected,
        startDragging,
        parameters,
        paths,
        macroPaths,
        setMacroToShow,
        setEffectParameterValues,
        getForceParameters
    });


    return [
        <CanvasRegions selected={selected} isRegionMode={isRegionMode}/>,
        <PlaneCanvas
          drawForces={drawForces}
          getForceParameters={getForceParameters}
          forcePaths={forcePaths}
          splineTension={splineTension}
          ctxt={ctxt}
          paths={paths}
          macroPaths={macroPaths}
          blur={props.blur}
          selectedColor={selectedColor}
          setMacroToShow={setMacroToShow}
          startDragging={startDragging}
          coords={coords}
          filteredParameters={filteredParameters}
          parameters={parameters}
          gradientColor={props.gradientColor}
          macroToShow={macroToShow}
          isFiltered={filteredParameters !== undefined}
          setParameterMinMax={setParameterMinMax}
          effect={effect}
          parameterSelected={parameterSelected}
          setEffectParameterValues={setEffectParameterValues}
          containerRef={containerRef}
          selected={selected}
          selection={selection}
          sequencerEngine={sequencerEngine}
          macros={macros}
         {... props}
            />,
       <ShaderCanvas
          coords={coords}
         effect={effect}/>,
        <Forces
          drawForces={drawForces}
          forcePaths={forcePaths}
          onClick={onClick}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          onMouseDown={onMouseDown}
          effect={effect} />
    ];
};

const mapStateToProps = (state, props) => {
  return {
      gradientColor: state.plane.gradientColors[props.effect.id],
      splineTension: props.effect.splineTension,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CanvasManager);
